/* globals strip */
(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('inventoryActionConfig', inventoryActionConfig);

	inventoryActionConfig.$inject = ['$rootScope', '$scope', '$timeout', '$compile', '$state',
		'$uibModal', '$translate', 'siteService', 'inventoryActionConfigService',
		'newProjectService', 'factorySettingService', 'procurementTaskService', 'storeService',
		'$experiments'];

	function inventoryActionConfig($rootScope, $scope, $timeout, $compile, $state, $uibModal,
			$translate, siteService, inventoryActionConfigService, newProjectService,
			factorySettingService, procurementTaskService, storeService, $experiments) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var isUnableToFixPage = ['app.company-setup.unable-to-fix-categories', 'app.setup.unable-to-fix-categories'].includes($state.current.name);
		var displayMap = {
			'MRPResize': 'MRP Resize',
			'VMILevel': 'MinMax Level',
			'POForExcess': 'POs to Action: Next 6 Months',
			'POForExcessLeadTime': 'POs to Action: Monthly',
			'PoReduction': 'PO Actions: Reduce Inventory',
			'ROPResize': 'ROP Resize',
			'ExcessToSell': 'Excess to Sell',
			'minThreshold': 'Opportunity to Open',
			'unableToFixBlockTimeMonths': 'Unable to Fix',
			'enabled': 'Enabled'
		};

		vm.factoryCurrencySymbol = globalConfig.user.authFacts[adminConfig.factory.id].currencySymbol;
		vm.showUnableToFixArchive = false;
		vm.showProcurementTaskArchive = false;
		vm.headerUnableToFixCheckboxClass = 'fa-square-o';
		vm.headerProcurementTaskCategoriesCheckboxClass = 'fa-square-o';
		vm.customerName = adminConfig.customer.name;
		vm.reportTitle = 'Inventory Actions & Tasks';
		vm.canMergeTasks = false;
		vm.startEdit = startEdit;
		vm.saveField = saveField;
		vm.saveList = saveList;
		vm.hideEdit = hideEdit;
		vm.filterUsers = filterUsers;
		vm.updateDefaultResponsible = updateDefaultResponsible;
		vm.updateExcessToSellDefaultResponsible = updateExcessToSellDefaultResponsible;
		vm.updateFactorySetting = updateFactorySetting;
		vm.addUnableToFixCategory = addUnableToFixCategory;
		vm.removeUnableToFixCategory = removeUnableToFixCategory;
		vm.archiveUnableToFixCategories = archiveUnableToFixCategories;
		vm.unArchiveUnableToFixCategories = unArchiveUnableToFixCategories;
		vm.archiveTaskCategories = archiveTaskCategories;
		vm.unArchiveTaskCategories = unArchiveTaskCategories;
		vm.mergeTaskCategories = mergeTaskCategories;
		vm.startAddCategory = startAddCategory;
		vm.showUnableToFixCategories = $rootScope.authz.isCustomerAdmin() && isUnableToFixPage;
		vm.updateBlackListSites = updateBlackListSites;
		vm.openBlacklistModal = openBlacklistModal;
		vm.showUnableToFixArchiveCategories = showUnableToFixArchiveCategories;
		vm.showProcumentTaskArchiveCategories = showProcumentTaskArchiveCategories;
		vm.toggleCheckboxRow = toggleCheckboxRow;
		vm.toggleAllCheckboxes = toggleAllCheckboxes;
		vm.currentlyNoneSelected = currentlyNoneSelected;
		vm.updateFactorySettingsNoTransform = updateFactorySettingsNoTransform;

		vm.editing = {};
		vm.inventoryActionTypes = null;
		vm.enabled = [
			{
				value: false,
				display: 'No'
			},
			{
				value: true,
				display: 'Yes'
			}
		];

		vm.actionRestrictionPeriod = [
			{
				key: 'NONE',
				display: 'None'
			}, {
				key: 'HOLIDAYS',
				display: 'Site Holidays'
			}, {
				key: 'HOLIDAYS_AND_WEEKENDS',
				display: 'Site Holidays + Weekends'
			}
		];

		vm.actions = [
			{
				value: 'Add Comment (optional)',
				display: 'Add Comment (optional)'
			},
			{
				value: 'Add Comment (required)',
				display: 'Add Comment (required)'
			},
			{
				value: 'Reassign',
				display: 'Reassign'
			}
		];

		vm.factoryNameList = [
			{
				value: 0,
				display: 'All Sites'
			},
			{
				value: adminConfig.factory.id,
				display:  adminConfig.factory.name
			}
		];

		vm.suppliers = null;
		vm.itemGroups = null;
		vm.materialGroups = null;
		vm.materialTypes = null;
		var maps = {
			suppliers: null,
			itemGroups: null,
			materialGroups: null,
			materialTypes: null
		};
		vm.users = null;
		vm.sites = null;
		vm.unableToFixCategories = undefined;
		vm.selected = {};
		vm.selected.defaultUser = null;
		vm.selected.defaultExcessToSellUser = null;
		vm.selected.blackListSitesOld = [];
		vm.isCustomerAdmin = $rootScope.authz.isCustomerAdmin();

		var enabledText = {
			0: 'No',
			1: 'Yes'
		};

		init();

		function init() {
			getExcessToSellSites();
			getInventoryActionTypes();
			getSuppliers();
			getItemGroups();
			getMaterialGroups();
			getMaterialTypes();
			getUsers();
			getDefaultResponsible();
			getExcessToSellDefaultResponsible();
			getUnableToFixCategories();
			getFactorySettings();
			getProcurementTaskCategories();
		}

		function getLeftNavWidth() {
			var rootNavigation = jQuery('#root-navigation');
			var leftNavigationParent = rootNavigation.parent();
			var leftMargin = parseInt(rootNavigation.width());
			if (!jQuery(leftNavigationParent).is('[class*="unpinned"]')) {
				leftMargin = parseInt(leftNavigationParent.width());
			}
			return leftMargin;
		}
	
		function getInventoryActionTypes() {
			inventoryActionConfigService.getActions(adminConfig.factory.id)
				.then(function initInventoryActionTypes(inventoryActionTypes) {
					vm.inventoryActionTypes = [];

					for (var i = 0; i < inventoryActionTypes.length; i++) {
						var actionType = inventoryActionTypes[i];
						// disabled types
						if (actionType.name === 'MRPResize' ||
								actionType.name === 'POForExcess' ||
								actionType.name === 'POForExcessLeadTime') {
							continue;
						}

						vm.inventoryActionTypes.push(actionType);

						actionType.display = displayMap[actionType.name];
						actionType.blacklistCount = {
							suppliers: 0,
							itemGroups: 0,
							materialGroups: 0,
							materialTypes: 0
						};
						actionType.blacklistDisplay = {
							suppliers: '',
							itemGroups: '',
							materialGroups: '',
							materialTypes: ''
						};
						var j;
						if (actionType.hasOwnProperty('supplierBlacklist')) {
							actionType.suppliers = actionType.supplierBlacklist.split(',');
							for (j = 0; j < actionType.suppliers.length; j++) {
								actionType.suppliers[j] = parseInt(actionType.suppliers[j]);
							}
						} else {
							actionType.suppliers = [];
						}
						if (actionType.hasOwnProperty('itemGroupBlacklist')) {
							actionType.itemGroups = actionType.itemGroupBlacklist.split(',');
							for (j = 0; j < actionType.itemGroups.length; j++) {
								actionType.itemGroups[j] = parseInt(actionType.itemGroups[j]);
							}
						} else {
							actionType.itemGroups = [];
						}
						if (actionType.hasOwnProperty('materialGroupBlacklist')) {
							// materialGroup is a string so can contain a comma
							actionType.materialGroups = actionType.materialGroupBlacklist.split('##,##');
						} else {
							actionType.materialGroups = [];
						}
						if (actionType.hasOwnProperty('materialTypeBlacklist')) {
							// materialType is a string so can contain a comma
							actionType.materialTypes = actionType.materialTypeBlacklist.split('##,##');
						} else {
							actionType.materialTypes = [];
						}
						actionType.enabledText = enabledText[actionType.enabled];
					}
					setBlacklistDisplayText();
				});
		}

		function getSuppliers() {
			inventoryActionConfigService.getSuppliers(adminConfig.factory.id)
				.then(function initSuppliers(suppliers) {
					vm.suppliers = suppliers;
					maps['suppliers'] = {};
					for (var i = 0; i < vm.suppliers.length; i++) {
						var supplier = vm.suppliers[i];
						maps.suppliers[supplier.supplierNdx] = supplier.supplierName;
					}
					setBlacklistDisplayText();
				});
		}
		function getItemGroups() {
			inventoryActionConfigService.getItemGroups(adminConfig.factory.id)
				.then(function initItemGroups(itemGroups) {
					vm.itemGroups = itemGroups;
					maps['itemGroups'] = {};
					for (var i = 0; i < vm.itemGroups.length; i++) {
						var itemGroup = vm.itemGroups[i];
						maps.itemGroups[itemGroup.itemGroupNdx] = itemGroup.itemGroupName;
					}
					setBlacklistDisplayText();
				});
		}
		function getMaterialGroups() {
			inventoryActionConfigService.getMaterialGroups(adminConfig.factory.id)
				.then(function initMaterialGroups(materialGroups) {
					vm.materialGroups = materialGroups;
					maps['materialGroups'] = {};
					for (var i = 0; i < vm.materialGroups.length; i++) {
						var materialGroup = vm.materialGroups[i];
						maps.materialGroups[materialGroup.materialGroup] = materialGroup.materialGroup;
					}
					setBlacklistDisplayText();
				});
		}
		function getMaterialTypes() {
			inventoryActionConfigService.getMaterialTypes(adminConfig.factory.id)
				.then(function initMaterialTypes(materialTypes) {
					vm.materialTypes = materialTypes;
					maps['materialTypes'] = {};
					for (var i = 0; i < vm.materialTypes.length; i++) {
						var materialType = vm.materialTypes[i];
						maps.materialTypes[materialType.materialType] = materialType.materialType;
					}
					setBlacklistDisplayText();
				});
		}
		function getUsers() {
			siteService.getUsersForSite(adminConfig.factory.id, true)
				.then(function initUsers(users) {
					vm.users = users;
					for (var i = 0; i < vm.users.length; i++) {
						var user = vm.users[i];
						user.name = user.firstName + ' ' + user.lastName;
					}
				});
		}
		function getDefaultResponsible() {
			inventoryActionConfigService.getDefaultResponsible(adminConfig.factory.id)
				.then(function initDefaultResponsible(responsible) {
					vm.selected.defaultUser = responsible;
				});
		}
		function getExcessToSellDefaultResponsible() {
			inventoryActionConfigService.getExcessToSellDefaultResponsible(adminConfig.factory.id)
				.then(function initExcessToSellDefaultResponsible(responsible) {
					if (responsible === -1) {
						responsible = null;
					}
					vm.selected.defaultExcessToSellUser = responsible;
				});
		}
		function getExcessToSellSites() {
			inventoryActionConfigService.getFactoriesForUserAndCustomer(adminConfig.factory.id)
				.then(function initExcessToSellSites(blackListSites) {
					vm.sites = blackListSites;
					getInventoryActionBlackListSites();
				});
		}
		function getInventoryActionBlackListSites() {
			inventoryActionConfigService.getInventoryActionBlackListSites(adminConfig.factory.id)
				.then(function initBlackListSites(blackListSites) {
					if (blackListSites && blackListSites.length > 0) {
						blackListSites = blackListSites.map(Number);
						vm.selected.blackListSites = blackListSites;
						vm.selected.blackListSitesOld = _.clone(vm.selected.blackListSites);
					}
				});
		}
		function checkForBlackListSiteChange() {
			if (!vm.selected.blackListSites && vm.selected.blackListSitesOld.length == 0) {
				return false;
			} else {
				var newValues = !vm.selected.blackListSites ? [] : vm.selected.blackListSites;
				return _.xor(newValues, vm.selected.blackListSitesOld);
			}
		}
		function filterUsers(searchTerm) {
			if (searchTerm === '') {
				return vm.users;
			}
			return newProjectService.filterUsers(vm.users, searchTerm);
		}

		function getUnableToFixCategories(showArchive) {
			if (vm.showUnableToFixCategories) {
				inventoryActionConfigService.getUnableToFixCategories(adminConfig.factory.id, !showArchive)
					.then(function initUnableToFixCategories(categories) {
						if (categories && categories.length) {
							for (var i = 0; i < categories.length; i++) {
								categories[i].categoryEnabled = categories[i].state === 'active' ? 1 : 0;
								categories[i].enabledText = enabledText[categories[i].categoryEnabled];

								if (categories[i].state === 'active') {
									vm.showHeaderToggle = true;
									categories[i].hasCheckBox = true;
									categories[i].checkbox = false;
								}
							}
						}
						vm.selected.unableToFixCategories = categories;
						vm.unableToFixCategories = categories;

						$timeout(function () {
							updateSelectAllBox(vm.unableToFixCategories, 'headerUnableToFixCheckboxClass');
						}, 0);
					});
			}
		}

		function getProcurementTaskCategories(showArchive) {
			inventoryActionConfigService.getProcurementTaskCategories(adminConfig.factory.id, !showArchive)
				.then(function initUnableToFixCategories(categories) {
					if (categories && categories.length) {
						for (var i = 0; i < categories.length; i++) {
							categories[i].categoryEnabled = categories[i].active ? 1 : 0;
							if (categories[i].active && categories[i].categoryName.toLowerCase() !== 'Inventory Action'.toLowerCase()) {
								vm.showHeaderToggle = true;
								if (($rootScope.authz.isCustomerAdmin()) || ($rootScope.authz.isAdmin() && categories[i].factoryNdx === adminConfig.factory.id)) {
									categories[i].hasCheckBox = true;
								}

								categories[i].checkbox = false;
							}

							if (categories[i].categoryName.toLowerCase() === 'Inventory Action'.toLowerCase()) {
								categories[i].notEditable = true;
							}
							categories[i].factoryNdx = categories[i].factoryNdx || 0;
						}
					}
					vm.selected.procurementTaskCategories = categories;
					vm.procurementTaskCategories = categories;

					$timeout(function () {
						updateSelectAllBox(vm.procurementTaskCategories, 'headerProcurementTaskCategoriesCheckboxClass');
					}, 0);
				});
		}

		function addUnableToFixCategory() {
			var newCategory = {};
			newCategory.categoryName = strip(vm.editing.categoryName);
			inventoryActionConfigService.addUnableToFixCategory(adminConfig.factory.id, newCategory)
				.then(function (response) {
					if (response && response.status && response.status < 400 && response.data && response.data.ndx) {
						$rootScope.$emit('toast', {
							'message': 'Unable to fix category created successfully'
						});
					} else if (response && response.status == 409) {
						var errorMessage = response.data.error;
						$rootScope.$emit('toast', {
							'message': errorMessage,
							'success': false
						});
					} else {
						$rootScope.$emit('toast', {
							'message': 'Failed to create unable to fix category',
							'success': false
						});
					}
					getUnableToFixCategories();
				});
			hideEdit();
		}

		function removeUnableToFixCategory(category) {
			inventoryActionConfigService.removeUnableToFixCategory(adminConfig.factory.id, category.ndx)
				.then(function (response) {
					if (response && response.status && response.status < 400) {
						$rootScope.$emit('toast', {
							'message': 'Unable to fix category removed'
						});
					} else {
						var errMessage = response && response.error && response.error.length ? response.error : 'Unable to remove category';
						$rootScope.$emit('toast', {
							'message': errMessage,
							'success': false
						});
					}
					getUnableToFixCategories();
				});
		}

		function showUnableToFixArchiveCategories() {
			getUnableToFixCategories(!vm.showUnableToFixArchive);
		}

		function archiveUnableToFixCategories() {
			var selectedCategories = getSelectedRowsForEdit(vm.unableToFixCategories);
			var listOfObjects = [];
			var listOfIds = [];
			angular.forEach(selectedCategories, function(category) {
				listOfObjects.push({
					ndx: category.ndx,
					state: 'inactive'
				});
				listOfIds.push(category.ndx);
			});

			var multipleSelectedCategories = selectedCategories.length > 1;
			function archive() {
				inventoryActionConfigService.updateUnableToFixCategories(adminConfig.factory.id, listOfIds.toString(), listOfObjects).then(function(response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {
							'message': 'Unable to fix ' + (multipleSelectedCategories ? 'categories' : 'category') + ' archived successfully'
						});
					} else if (response && response.status == 409) {
						var errorMessage = response.data.error;
						$rootScope.$emit('toast', {
							'message': errorMessage,
							'success': false
						});
					} else {
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
					getUnableToFixCategories(vm.showUnableToFixArchive);
				});
			}
			confirm($scope, $uibModal, '', 'archive ' + (multipleSelectedCategories ? 'these' : 'this') + ' Unable to Fix ' + (multipleSelectedCategories ? 'categories' : 'category'), 'Yes', archive);

		}

		function unArchiveUnableToFixCategories(category, state) {
			if (!category) {
				return;
			}
			var saveObj = {
				ndx: category.ndx,
				state: state
			};

			function archive() {
				inventoryActionConfigService.updateUnableToFixCategory(adminConfig.factory.id, saveObj).then(function(response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {
							'message': 'Unable to fix category ' + (saveObj.state === 'inactive' ? 'archived' : 'restored') + ' successfully'
						});
					} else if (response && response.status == 409) {
						var errorMessage = response.data.error;
						$rootScope.$emit('toast', {
							'message': errorMessage,
							'success': false
						});
					} else {
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
					getUnableToFixCategories(vm.showUnableToFixArchive);
				});
			}

			if (state === 'active') {
				archive();
			} else {
				confirm($scope, $uibModal, '', 'archive this unable to fix category', 'Yes', archive);
			}
		}

		function archiveTaskCategories() {
			var selectedCategories = getSelectedRowsForEdit(vm.procurementTaskCategories);
			var listOfObjects = [];
			angular.forEach(selectedCategories, function(category) {
				listOfObjects.push({
					id: category.ndx,
					active: false,
					name: category.categoryName,
					factoryNdx: category.factoryNdx
				});
			});

			var multipleSelectedCategories = selectedCategories.length > 1;
			function archive() {
				procurementTaskService.updateCategoryStatus(adminConfig.factory.id, listOfObjects).then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {
							'message': 'Procurement Task ' + (multipleSelectedCategories ? 'categories' : 'category') + ' archived successfully'
						});
					} else if (response && response.status == 409) {
						var errorMessage = response.data.error;
						$rootScope.$emit('toast', {
							'message': errorMessage,
							'success': false
						});
					} else {
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
					getProcurementTaskCategories(vm.showProcurementTaskArchive);
				});
			}
			confirm($scope, $uibModal, '', 'archive ' + (multipleSelectedCategories ? 'these' : 'this') + ' Procurement Task ' + (multipleSelectedCategories ? 'categories' : 'category'), 'Yes', archive);
		}

		function unArchiveTaskCategories(category, state) {
			if (!category) {
				return;
			}
			var saveObj = {
				id: category.ndx,
				active: state,
				name: category.categoryName,
				factoryNdx: category.factoryNdx
			};
			function archive() {
				procurementTaskService.updateCategoryStatus(adminConfig.factory.id, [saveObj]).then(function(response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {
							'message': 'Procurement Task category ' + (state ? 'enabled' : 'archived') +  ' successfully'
						});
					} else if (response && response.status == 409) {
						var errorMessage = response.data.error;
						$rootScope.$emit('toast', {
							'message': errorMessage,
							'success': false
						});
					} else {
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
					getProcurementTaskCategories(vm.showProcurementTaskArchive);
				});
			}
			confirm($scope, $uibModal, '', (state ? 'enable' : 'archive') + ' this Procurement Task category', 'Yes', archive);
		}

		function showProcumentTaskArchiveCategories() {
			getProcurementTaskCategories(vm.showProcurementTaskArchive);
		}

		var blacklistNames = ['suppliers', 'itemGroups', 'materialGroups', 'materialTypes'];
		var blacklistDisplayNames = {
			'suppliers': {
				1: 'supplier',
				2: 'suppliers'
			},
			'itemGroups': {
				1: 'item group',
				2: 'item groups'
			},
			'materialGroups': {
				1: 'material group',
				2: 'material groups'
			},
			'materialTypes': {
				1: 'material type',
				2: 'material types'
			}
		};

		function setBlacklistDisplayText() {
			if (vm.inventoryActionTypes == null) {
				return;
			}
			for (var i = 0; i < vm.inventoryActionTypes.length; i++) {
				var actionType = vm.inventoryActionTypes[i];
				var blacklistName;

				for (var j = 0; j < blacklistNames.length; j++) {
					blacklistName = blacklistNames[j];
					if (vm[blacklistName] != null &&
							maps[blacklistName] != null) {
						var names = [];
						var validEntries = [];
						for (var k = 0; k < actionType[blacklistName].length; k++) {
							var id = actionType[blacklistName][k];
							// exclude any ids that don't exist anymore
							if (maps[blacklistName].hasOwnProperty(id)) {
								names.push(maps[blacklistName][id]);
								validEntries.push(id);
							}
						}
						actionType[blacklistName] = validEntries;

						actionType.blacklistCount[blacklistName] = names.length;
						actionType.blacklistDisplay[blacklistName] = names.join(', ');
					}
				}

				var nonEmptyLists = [];
				for (blacklistName in actionType.blacklistCount) {
					if (actionType.blacklistCount.hasOwnProperty(blacklistName)) {
						var count = actionType.blacklistCount[blacklistName];
						var displayNames = blacklistDisplayNames[blacklistName];
						if (count > 0) {
							var displayName = count > 1 ? displayNames[2] : displayNames[1];
							nonEmptyLists.push(count + ' ' + $translate.instant(displayName));
						}
					}
				}
				actionType.blacklistDisplay.all = nonEmptyLists.join(', ');
			}
		}

		var getTemplate = {
			'enabled': getListTemplate,
			'categoryEnabled': getListTemplate,
			'action': getListTemplate,
			'factoryNdx': getRadioTemplate,
			'minThreshold': getNumberTemplate,
			'unableToFixBlockTimeMonths': getNumberTemplate,
			'message': getTextAreaTemplate,
			'categoryName': getTextTemplate
		};

		var listPropertyMap = {
			'enabled': {
				listName: 'enabled',
				listLabel: 'enabled',
				listPlaceholder: 'Enabled'
			},
			'categoryEnabled': {
				listName: 'enabled',
				listLabel: 'enabled',
				listPlaceholder: 'Enabled'
			},
			'action': {
				listName: 'actions',
				listLabel: 'action',
				listPlaceholder: 'Action'
			},
			'factoryNdx': {
				listName: 'factoryNameList',
				listLabel: 'factory',
				listPlaceholder: 'Factory'
			}
		};

		function startEdit(row, rowIndex, fieldName, type, idPrefix) {
			hideEdit();
			idPrefix = idPrefix || fieldName;
			var identifier = type === 'actionType' ? row.name : row.ndx;
			vm.editing[fieldName] = row[fieldName];
			var cell = jQuery('#' + idPrefix + rowIndex);
			var embeddedBody = jQuery('.embeddedBody');
			var cellOffset = cell.offset();
			var embeddedBodyOffset = embeddedBody.offset();
			// Calculate position relative to .embeddedBody (which has position: relative)
			var pos = {
				left: cellOffset.left - embeddedBodyOffset.left,
				top: cellOffset.top - embeddedBodyOffset.top + embeddedBody.scrollTop() + 15
			};
			var editTemplate = getTemplate[fieldName](pos, identifier, fieldName, type, vm.factoryNameList, true);
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				// enter key pressed and field has valid value
				if (code === 13 && vm.editing[fieldName] !== undefined) {
					if (fieldName === 'categoryName' && _.trim(vm.editing[fieldName]) === '') {
						return;
					}
					saveField(identifier, fieldName, type);
				} else if (code === 27) {
					hideEdit();
				}
			});
			window.setTimeout(function () {
				if (fieldName !== 'message') {
					jQuery('.inlineEditDiv input').select();
				} else {
					jQuery('.inlineEditDiv textarea').select();
				}
			}, 100);
			vm.inlineActive = true;
		}

		function startAddCategory(fieldId, isTaskCategory) {
			hideEdit();
			fieldId = fieldId || 'add-category-button';
			var type = isTaskCategory ? 'procurementTask': undefined;
			vm.editing.categoryName = '';
			var elem = jQuery('#' + fieldId);
			var embeddedBody = jQuery('.embeddedBody');
			var elemOffset = elem.offset();
			var embeddedBodyOffset = embeddedBody.offset();
			// Calculate position relative to .embeddedBody (which has position: relative)
			// Subtract 100px to position modal to the left of the button
			var pos = {
				left: elemOffset.left - embeddedBodyOffset.left - 100,
				top: elemOffset.top - embeddedBodyOffset.top + embeddedBody.scrollTop() + 15
			};
			var editTemplate = getTextTemplate(pos, '', undefined, type, vm.factoryNameList, false);
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				// enter key pressed and field has valid value
				if (code === 13 && vm.editing.categoryName !== undefined && _.trim(vm.editing.categoryName) !== '') {
					if (!isTaskCategory) {
						addUnableToFixCategory();
					} else {
						saveProcurmentTaskField(undefined, 'categoryName');
					}
				} else if (code === 27) {
					hideEdit();
				}
			});
			window.setTimeout(function () {
				jQuery('.inlineEditDiv input').select();
			}, 100);
			vm.inlineActive = true;
		}

		function openBlacklistModal(row) {
			var editBlacklistScope = $scope.$new();
			editBlacklistScope.actionType = row;
			vm.editing.suppliers = [];
			var i;
			if (typeof row.suppliers !== null) {
				for (i = 0; i < row.suppliers.length; i++) {
					vm.editing.suppliers.push(row.suppliers[i]);
				}
			}
			vm.editing.itemGroups = [];
			if (typeof row.itemGroups !== null) {
				for (i = 0; i < row.itemGroups.length; i++) {
					vm.editing.itemGroups.push(row.itemGroups[i]);
				}
			}
			vm.editing.materialGroups = [];
			if (typeof row.materialGroups !== null) {
				for (i = 0; i < row.materialGroups.length; i++) {
					vm.editing.materialGroups.push(row.materialGroups[i]);
				}
			}
			vm.editing.materialTypes = [];
			if (typeof row.materialTypes !== null) {
				for (i = 0; i < row.materialTypes.length; i++) {
					vm.editing.materialTypes.push(row.materialTypes[i]);
				}
			}
			var opts = {
				scope: editBlacklistScope,
				templateUrl: '/application/f/setup/edit_inventory_action_blacklist.html'
			};

			var instance = $uibModal.open(opts);

			editBlacklistScope.closeDialog = function () {
				instance.close();
				editBlacklistScope.$destroy();
			};

			editBlacklistScope.save = function (actionType, actionDisplayName) {
				saveList(actionType, actionDisplayName);
				instance.close();
				editBlacklistScope.$destroy();
			};
		}

		function getListTemplate(position, identifier, fieldName, type) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (jQuery('.embeddedBody').scrollTop()) {
				windowHeight = windowHeight + jQuery('.embeddedBody').scrollTop();
			}
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth + 28);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var listProperties = listPropertyMap[fieldName];
			var editTemplate = '<div class="inlineEditDiv absolute textEdit" style="top:' +
				position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">Change ' + listProperties.listLabel + ' state</div>' +
				'<ui-select append-to-body="true" theme="bootstrap" ng-model="actionConfigCtrl.editing.' + fieldName + '">' +
				'<ui-select-match placeholder="{{\'Select ' + listProperties.listPlaceholder + '...\' | translate}}">' +
				'{{$select.selected.display}}' +
				'</ui-select-match>' +
				'<ui-select-choices repeat="item.value as item in actionConfigCtrl.' + listProperties.listName + ' | filter: $select.search">' +
				'{{item.display}}' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="actionConfigCtrl.hideEdit()">Cancel</button>' +
				'<button class="button flat colored" ' +
				'ng-click="actionConfigCtrl.saveField(\'' + identifier + '\', \'' + fieldName + '\', \'' + type + '\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function getNumberTemplate(position, actionTypeName, fieldName) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (jQuery('.embeddedBody').scrollTop()) {
				windowHeight = windowHeight + jQuery('.embeddedBody').scrollTop();
			}
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			// minThreshold header
			var header = 'Change Min Savings Threshold';
			if (fieldName === 'unableToFixBlockTimeMonths') {
				header = 'Change Unable to Fix Number of Months to Block New';
			}
			var editTemplate = '<div class="inlineEditDiv absolute textEdit" ' +
				'style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">' + header + '</div>' +
				'<input class="inlineEditInput" ng-model="actionConfigCtrl.editing.' + fieldName + '" type="number" min="1"/>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ' +
				'ng-click="actionConfigCtrl.hideEdit()">Cancel</button>' +
				'<button class="button flat colored" ng-disabled="!actionConfigCtrl.editing.' + fieldName + ' || actionConfigCtrl.editing.' + fieldName + ' <= 0"' +
				'ng-click="actionConfigCtrl.saveField(\'' + actionTypeName +
				'\', \'' + fieldName + '\', \'actionType\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function getTextAreaTemplate(position, identifier) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (jQuery('.embeddedBody').scrollTop()) {
				windowHeight = windowHeight + jQuery('.embeddedBody').scrollTop();
			}
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 180 > windowHeight) {
				position.top = position.top - (position.top + 180 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv absolute textAreaEditSmaller" ' +
				'style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">Change Message</div>' +
				'<textarea style="max-height: 60px; height: 100%" class="inlineEditInput" ng-model="actionConfigCtrl.editing.message"></textarea>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ' +
				'ng-click="actionConfigCtrl.hideEdit()">Cancel</button>' +
				'<button class="button flat colored"' +
				'ng-click="actionConfigCtrl.saveField(\'' + identifier +
				'\', \'message\', \'category\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function getTextTemplate(position, identifier, fieldName, type, factories, isEdit) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (jQuery('.embeddedBody').scrollTop()) {
				windowHeight = windowHeight + jQuery('.embeddedBody').scrollTop();
			}
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth + 28);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			type = type || 'category';
			fieldName = fieldName || 'categoryName';
			var label = (isEdit ? 'Edit' : 'Add') + (type === 'procurementTask' ? ' Procurement Task Category': ' Unable to Fix Category');
			var editTemplate = '<div class="inlineEditDiv absolute textEdit" ' +
				'style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">' + label + '</div>' +
				'<input class="inlineEditInput" ng-model="actionConfigCtrl.editing.categoryName"/>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ' +
				'ng-click="actionConfigCtrl.hideEdit()">Cancel</button>' +
				'<button class="button flat colored" ng-disabled="!actionConfigCtrl.editing.categoryName || !actionConfigCtrl.editing.categoryName.length"' +
				(identifier || type === 'procurementTask' ? ' ng-click="actionConfigCtrl.saveField(\'' + identifier + '\', \'' + fieldName + '\', \'' + type + '\', \'' + isEdit + '\')"': ' ng-click="actionConfigCtrl.addUnableToFixCategory()"')  +
				'>Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function getRadioTemplate(position, identifier, fieldName, type, records, isEdit) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			var height = 122 + (records.length * 15);
			if (jQuery('.embeddedBody').scrollTop()) {
				windowHeight = windowHeight + jQuery('.embeddedBody').scrollTop();
			}
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth + 28);
			}
			if (position.top + height > windowHeight) {
				position.top = position.top - (position.top + height + 20 - windowHeight);
			}
			type = type || 'category';
			fieldName = fieldName || 'categoryName';

			var label = 'Make this Category available in:';
			var editTemplate = '<div class="inlineEditDiv absolute textEdit" ' +
				'style="top:' + position.top + 'px; left: ' + position.left + 'px;height:' + height + 'px;">' +
				'<div class="inlineEditHeader">' + label + '</div>';

			angular.forEach(records, function (record) {
				editTemplate += '<div class="radio">' +
					'<label><input type="radio" name="optradio" ng-model="actionConfigCtrl.editing.' + fieldName + '" value="' + record.value + '" ng-checked="actionConfigCtrl.editing.' + fieldName + ' === ' + record.value + '">' +
					'<span style="margin-top: 4px;position: absolute;">' + record.display + '</span></label></div>';
			});

			editTemplate += '<div class="inlineEditButtons">' +
				'<button class="button flat" ' +
				'ng-click="actionConfigCtrl.hideEdit()">Cancel</button>' +
				'<button class="button flat colored" ' +
				(identifier || type === 'procurementTask' ? ' ng-click="actionConfigCtrl.saveField(\'' + identifier + '\', \'' + fieldName + '\', \'' + type + '\', \'' + isEdit + '\')"': ' ng-click="actionConfigCtrl.addUnableToFixCategory()"')  +
				'>Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function saveField(identifier, fieldName, type, isEdit) {
			if (type === 'actionType') {
				saveActionTypeField(identifier, fieldName);
			} else if (type === 'procurementTask') {
				saveProcurmentTaskField(identifier, fieldName, JSON.parse(isEdit));
			} else {
				saveUnableToFixCategoryField(identifier, fieldName);
			}

			hideEdit();
		}

		function saveProcurmentTaskField(identifier, fieldName, isEdit) {
			var fieldNameToFieldMapping = {
				'categoryName': 'name',
				'factoryNdx': 'factoryNdx'
			};
			var fieldNameToLabelMapping = {
				'categoryName': 'name',
				'factoryNdx': 'site'
			};
			var saveObject = {
				'factoryNdx': adminConfig.factory.id
			};
			saveObject[fieldNameToFieldMapping[fieldName]] = vm.editing[fieldName];
			if (identifier && identifier != '') {
				saveObject['id'] = parseInt(identifier);
			}

			if (fieldName === 'categoryName') {
				var category = saveObject['id'] ? _.find(vm.procurementTaskCategories, {ndx: saveObject['id']}) : undefined;
				if (category) {
					if (category['categoryName'] === strip(vm.editing[fieldName])) {
						// no change
						return;
					}
				} else if (_.some(vm.procurementTaskCategories, ['categoryName', strip(vm.editing[fieldName])])) {
					$rootScope.$emit('toast', {
						'success': false,
						'message': 'Procurement Task Category already exists'
					});
					return;
				}
			}

			function saveProcurementTaskCategory() {
				procurementTaskService.addCategory(saveObject, adminConfig.factory.id).then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {'message': 'Procurement Task Category ' +
								 (isEdit ? fieldNameToLabelMapping[fieldName] + ' saved' : 'created successfully'), 'success': true});
						getProcurementTaskCategories(vm.showProcurementTaskArchive);
					} else if (response && response.status && response.status === 409) {
						$rootScope.$emit('toast', {'message': response.data.error, 'success': false});
					} else {
						$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
					}
				});
			}

			if (fieldName === 'factoryNdx') {
				if (vm.editing[fieldName] === '0') {
					confirm($scope, $uibModal, 'You can\'t switch \'All\' back to a specific site. ', 'change site to All', 'Yes', saveProcurementTaskCategory);
				}
			} else {
				saveProcurementTaskCategory();
			}
		}

		function saveActionTypeField(actionTypeName, fieldName) {
			var saveObject = {
				type: actionTypeName
			};
			saveObject[fieldName] = vm.editing[fieldName];
			inventoryActionConfigService.saveInventoryActionConfig(
				adminConfig.factory.id, saveObject
			).then(function (response) {
				getInventoryActionTypes();
				$rootScope.$emit('toast', {
					'message': displayMap[actionTypeName] + ' ' + displayMap[fieldName] + ' value updated'
				});
			});
		}

		function saveUnableToFixCategoryField(categoryNdx, fieldName) {
			var saveObject = {
				ndx: categoryNdx
			};
			var category = _.find(vm.unableToFixCategories, { ndx: parseInt(categoryNdx) });
			if (!category) {
				return;
			}
			// TODO handle state differently
			if (fieldName === 'categoryEnabled') {
				saveObject.state = vm.editing[fieldName] === 0 ? 'inactive' : 'active';
				if (category.state === saveObject.state) {
					// no change
					return;
				}
			} else {
				saveObject[fieldName] = strip(vm.editing[fieldName]);
				if (saveObject[fieldName] === category[fieldName]) {
					// no change
					return;
				}
			}
			inventoryActionConfigService.updateUnableToFixCategory(adminConfig.factory.id, saveObject).then(function(response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					getUnableToFixCategories();
					$rootScope.$emit('toast', {
						'message': 'Unable to fix category updated successfully'
					});
				} else if (response && response.status == 409) {
					var errorMessage = response.data.error;
					$rootScope.$emit('toast', {
						'message': errorMessage,
						'success': false
					});
				} else {
					$rootScope.$emit('toast', {
						'message': 'Unexpected server error',
						'success': false
					});
				}

			});
		}

		function updateDefaultResponsible(responsibleUserId) {
			if (responsibleUserId === undefined) {
				responsibleUserId = 2234;
			}
			vm.selected.defaultUser = responsibleUserId;

			inventoryActionConfigService.saveDefaultResponsible(
				adminConfig.factory.id, responsibleUserId);
		}

		function updateExcessToSellDefaultResponsible(responsibleUserId) {
			vm.selected.defaultExcessToSellUser = responsibleUserId;
			if (responsibleUserId === null) {
				responsibleUserId = -1;
			}

			inventoryActionConfigService.saveExcessToSellDefaultResponsible(
				adminConfig.factory.id, responsibleUserId);
		}

		function getFactorySettings() {
			vm.factorySettingsMeta = {
				actionsPerDay: {
					name: 'INVENTORY_ACTION_NUMBER_PER_DAY',
					defaultValue: 10,
					originalValueFieldName: 'originalActionsPerDay'
				},
				actionsPerDayPerBuyer: {
					name: 'INVENTORY_ACTION_NUMBER_PER_DAY_PER_BUYER',
					defaultValue: 10,
					originalValueFieldName: 'originalActionsPerDayPerBuyer'
				},
				poMonthlyNumberOfMonths: {
					name: 'INVENTORY_ACTION_MONTHLY_NUMBER_OF_MONTHS',
					defaultValue: 10,
					originalValueFieldName: 'originalPOMonthlyNumberOfMonths'
				},
				ActionRestrictionPeriod: {
					name: 'ACTION_RESTRICTION_PERIOD',
					defaultValue: 'None',
					originalValueFieldName: 'ActionRestrictionPeriod'
				},
				excludeHolidaysFromReceivingAndBufferTime: {
					name: 'EXCLUDE_HOLIDAYS_FROM_RECEIVING_AND_BUFFER_TIME',
					defaultValue: false,
					originalValueFieldName: 'excludeHolidaysFromReceivingAndBufferTime'
				},
				IncludePRinInventoryActionsFlag: {
					name:'INVENTORY_ACTION_INCLUDE_PRS_IN_INVENTORY_ACTIONS_FLAG',
					defaultValue:'0',
					originalValueFieldName: 'IncludePRinInventoryActionsFlag'
				}
			};
			var factorySettingNames = [];
			for (var fieldName in vm.factorySettingsMeta) {
				factorySettingNames.push(vm.factorySettingsMeta[fieldName].name);
			}

			factorySettingService.getFactorySettings(factorySettingNames, adminConfig.factory.id)
				.then(function initFactorySettings(factorySettings) {
					for (var fieldName in vm.factorySettingsMeta) {
						var factorySetting = vm.factorySettingsMeta[fieldName];
						var initialValue = factorySettings[factorySetting.name];
						vm.selected[fieldName] = initialValue;
						vm.selected[factorySetting.originalValueFieldName] = initialValue;
					}
				});
		}

		function updateFactorySetting(fieldName) {
			var factorySetting = vm.factorySettingsMeta[fieldName];
			var updatedValue = vm.selected[fieldName];
			vm.selected[factorySetting.originalValueFieldName] = updatedValue;
			if (updatedValue === null) {
				updatedValue = factorySetting.defaultValue;
			}

			updateFactorySettingsNoTransform(factorySetting.name, updatedValue);
		}

		function updateFactorySettingsNoTransform(factorySettingName, value) {
			var updateObject = {};
			updateObject[factorySettingName] = value;
			factorySettingService.saveFactorySettings(updateObject, adminConfig.factory.id);
		}

		function updateBlackListSites() {
			if (checkForBlackListSiteChange()) {
				var valueToSave = !vm.selected.blackListSites || vm.selected.blackListSites.length == 0 ?
					'NO_BLACK_LIST_SITES' : vm.selected.blackListSites.toString();
				inventoryActionConfigService.saveExcessToSellBlackListSites(
					adminConfig.factory.id, valueToSave).then(function() {
					vm.selected.blackListSitesOld = !vm.selected.blackListSites ? [] :
						_.clone(vm.selected.blackListSites);
				});
			}
		}

		function saveList(actionTypeName, actionDisplayName) {

			var saveObject = {
				type: actionTypeName
			};
			saveObject.supplierBlacklist = vm.editing.suppliers;
			saveObject.itemGroupBlacklist = vm.editing.itemGroups;
			saveObject.materialGroupBlacklist = vm.editing.materialGroups;
			saveObject.materialTypeBlacklist = vm.editing.materialTypes;
			inventoryActionConfigService.saveInventoryActionConfig(
				adminConfig.factory.id, saveObject
			).then(function (response) {
				getInventoryActionTypes();
				$rootScope.$emit('toast', {
					'message': actionDisplayName + ' exclusion lists saved'
				});
			});
			hideEdit();
		}

		function hideEdit() {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			vm.inlineActive = false;
		}

		function mergeTaskCategories() {
			var selectedTaskCategories = getSelectedRowsForEdit(vm.procurementTaskCategories);
			if (selectedTaskCategories.length > 1) {
				var mergeCategories;
				var hasAllSite = _.some(selectedTaskCategories, ['factoryNdx', 0]);
				var hasSingleSite = _.some(selectedTaskCategories, ['factoryNdx', adminConfig.factory.id]);
				var categoryIds = _.map(selectedTaskCategories, 'ndx');

				if ($rootScope.authz.isCustomerAdmin()) {
					if (hasAllSite) {
						mergeCategories = _.filter(selectedTaskCategories, function(category) {
							return category.factoryNdx === 0;
						});
					} else {
						mergeCategories = selectedTaskCategories;
					}
				} else if ($rootScope.authz.isAdmin()) {
					mergeCategories = _.filter(selectedTaskCategories, function(category) {
						return category.factoryNdx === adminConfig.factory.id;
					});
				}

				if (mergeCategories) {
					var mergeCategoriesScope = $scope.$new();
					mergeCategoriesScope.hasAllSite = hasAllSite;
					mergeCategoriesScope.hasSingleSite = hasSingleSite;
					mergeCategoriesScope.totalCategories = selectedTaskCategories.length;
					mergeCategoriesScope.list = {};
					mergeCategoriesScope.list.mergeCategories = mergeCategories;
					mergeCategoriesScope.selected = {
						category: mergeCategories[0]
					};
					var opts = {
						scope: mergeCategoriesScope,
						templateUrl: '/application/f/setup/supplyChain/merge_procurement_task_categories.html'
					};

					var instance = $uibModal.open(opts);

					mergeCategoriesScope.closeDialog = function () {
						instance.close();
						mergeCategoriesScope.$destroy();
					};

					mergeCategoriesScope.merge = function (category) {
						procurementTaskService.mergeCategories(adminConfig.factory.id, category.ndx, categoryIds).then(function (response) {
							getProcurementTaskCategories(vm.showProcurementTaskArchive);
							$rootScope.$emit('toast', {
								'message': 'Procurement Task Categories merged.'
							});
						});
						instance.close();
						mergeCategoriesScope.$destroy();
					};
				}
			}
		}
		// Checkbox functions

		function updateSelectAllBox(list, headerClass) {
			vm.canMergeTasks = false;
			var notAllSelected = _.filter(list, function (task) {
				return task.hasCheckBox && !task.checkbox;
			}).length;
			var notNoneSelected = getSelectedRowsForEdit(list).length;
			var newClass = '';
			if (notAllSelected && notNoneSelected) {
				newClass = 'fa-minus-square';
			} else if (notAllSelected) {
				newClass = 'fa-square-o';
			} else {
				newClass = 'fa-check-square';
			}
			vm[headerClass] = newClass;

			if (headerClass === 'headerProcurementTaskCategoriesCheckboxClass' && notNoneSelected > 1) {
				vm.canMergeTasks = true;
			}
		}

		function toggleCheckboxRow($row, list, headerClass) {
			if ($row) {
				$row['checkbox'] = !$row.checkbox;
			}
			$timeout(function () {
				updateSelectAllBox(list, headerClass);
			}, 0);
		}

		function selectAllCheckboxes(list, headerClass) {
			angular.forEach(list, function (row) {
				if (row.hasCheckBox) {
					row.checkbox = true;
				}
			});
			vm[headerClass] = 'fa-check-square';
		}

		function deselectAllCheckboxes(list, headerClass) {
			angular.forEach(list, function (row) {
				row.checkbox = false;
			});
			vm[headerClass] = 'fa-square-o';
		}

		function toggleAllCheckboxes(list, headerClass) {
			var anySelected = getSelectedRowsForEdit(list).length;
			if (anySelected) {
				deselectAllCheckboxes(list, headerClass);
			} else {
				selectAllCheckboxes(list, headerClass);
			}
		}

		function currentlyNoneSelected(list) {
			if (!list || !list.length) return true;
			for (var i = 0; i < list.length; i++) {
				if (list[i].checkbox) return false;
			}
			return true;
		}

		function getSelectedRowsForEdit(list) {
			return _.filter(list, function(task) {
				return task.checkbox;
			});
		}
	}
})();
